/**
 * ShowMore
 * ======================================
 * - hides items above a limit (data-show-more-limit, default 5)
 * - reveals remaining items on button click
 * - markup: js-show-more (wrapper), js-show-more-btn (next sibling button)
 */

const WIDGET = '.js-show-more';
const BTN = '.js-show-more-btn';
const HIDDEN_CLASS = 'is-hidden';

class ShowMore {
  constructor() {
    document.querySelectorAll(WIDGET).forEach((widget) => {
      const limit = parseInt(widget.dataset.showMoreLimit) || 5;
      const items = [...widget.children];
      const btn = widget.nextElementSibling?.matches(BTN)
        ? widget.nextElementSibling
        : widget.nextElementSibling?.querySelector(BTN);

      items.forEach((item, i) => {
        if (i >= limit) item.classList.add(HIDDEN_CLASS);
      });

      if (!btn) return;

      if (items.length <= limit) {
        btn.setAttribute('hidden', 'hidden');
        return;
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        items.forEach((item) => item.classList.remove(HIDDEN_CLASS));
        btn.setAttribute('hidden', 'hidden');
      });
    });
  }
}

new ShowMore();
